import React, { useCallback, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Input } from 'antd';
import { debounce } from 'underscore';

import { measurementConversion } from '../../utils/javascript';
import { DESIGN_LAYOUT_TOOLBAR } from '../LayoutToolbar/translationValues';
import { ToolbarContainer } from './styles';

export const ELEMENT_POSITION_TOOLBAR_ID = 'element-position-toolbar';

const NAMESPACES = ['DESIGN_LAYOUT_TOOLBAR'];

export const ElementPositionToolbar = ({
  targets,
  targetPosition,
  getFrame,
  updateStoredElementDetails,
  selectedElement,
  measurement = 'mm'
}) => {
  const [left, setLeft] = useState(0);
  const [top, setTop] = useState(0);
  const { t } = useTranslation(NAMESPACES);
  const currentTarget = targets[0];

  useEffect(() => {
    let fromLeft, fromTop;
    if (targetPosition) {
      if (measurement === 'mm') {
        fromLeft = measurementConversion(targetPosition.left, 'mm');
        fromTop = measurementConversion(targetPosition.top, 'mm');
      } else {
        fromLeft = targetPosition.left;
        fromTop = targetPosition.top;
      }
    } else {
      const frame = getFrame(currentTarget);
      const translateX = frame.properties.transform.translateX.split('px')[0];
      const translateY = frame.properties.transform.translateY.split('px')[0];
      if (measurement === 'mm') {
        fromLeft = measurementConversion(translateX, 'mm');
        fromTop = measurementConversion(translateY, 'mm');
      } else {
        fromLeft = translateX;
        fromTop = translateY;
      }
    }
    setLeft(fromLeft);
    setTop(fromTop);
  }, [targets, targetPosition, getFrame, currentTarget]);

  const updateElementStyle = (event, position) => {
    let valueInMM = event;
    if (valueInMM === '') {
      valueInMM = 0;
    }
    let valueInPx = valueInMM;
    if (measurement === 'mm') {
      valueInPx = measurementConversion(valueInMM, 'px');
    }
    const newStyle = {};
    const frame = getFrame(currentTarget);
    if (position === 'left') {
      frame.set('tx', String(valueInPx));
      newStyle.x = valueInPx;
    } else {
      frame.set('ty', String(valueInPx));
      newStyle.y = valueInPx;
    }
    const updateObject = {
      style: newStyle,
    };
    if (selectedElement.contents) {
      updateObject.contents = selectedElement.contents;
    }
    // have to update the style with content, otherwise frame of the box will not move.
    updateStoredElementDetails(
      currentTarget.getAttribute('data-uuid'),
      updateObject,
      'contents-with-style',
    );
  };

  const debouncedUpdateElementStyle = useCallback(debounce(updateElementStyle, 300), [
    targets,
    selectedElement,
  ]);

  return (
    <ToolbarContainer>
      <label>
        {t(DESIGN_LAYOUT_TOOLBAR.LEFT_LABEL.key, DESIGN_LAYOUT_TOOLBAR.LEFT_LABEL.value)}
      </label>
      <Input
        value={left}
        suffix={measurement}
        onChange={e => {
          setLeft(e.target.value);
          debouncedUpdateElementStyle(e.target.value, 'left');
        }}
        type="number"
      />
      <label>{t(DESIGN_LAYOUT_TOOLBAR.TOP_LABEL.key, DESIGN_LAYOUT_TOOLBAR.TOP_LABEL.value)}</label>
      <Input
        value={top}
        suffix={measurement}
        onChange={e => {
          setTop(e.target.value);
          debouncedUpdateElementStyle(e.target.value, 'top');
        }}
        type="number"
      />
    </ToolbarContainer>
  );
};
